<template>
    <table-ish>
        <template v-for="employer in employers">
            <table-ish-row
                :key="`row-${employer.uuid}`"
                @click="toggle(employer.uuid)"
                class="cursor-pointer hover:text-blue"
            >
                <table-ish-cell :shrink="true">
                    <base-svg
                        :name="isExpanded(employer.uuid) ? 'icon-cheveron-up' : 'icon-cheveron-down'"
                        :key="isExpanded(employer.uuid) ? 'icon-cheveron-up' : 'icon-cheveron-down'"
                        class="w-6 h-6 fill-primary-blue"
                    />
                </table-ish-cell>

                <table-ish-cell>
                    {{ employer.name }}
                </table-ish-cell>
            </table-ish-row>

            <table-ish-row
                v-if="isExpanded(employer.uuid)"
                :key="`detail-${employer.uuid}`"
            >
                <td
                    colspan="3"
                    class="bg-grey-bg pt-3 px-4 sm:px-6 md:pt-4 md:pb-1"
                >
                    <grid-layout>
                        <grid-layout-item class="sm:w-1/2 lg:w-1/3 mb-3">
                            <div class="text-label text-xs">Job title/position</div>
                            <div class="text-sm">
                                {{ employer.job_title }}
                            </div>
                        </grid-layout-item>

                        <grid-layout-item class="sm:w-1/2 lg:w-1/3 mb-3">
                            <div class="text-label text-xs">Monthly take home</div>
                            <div class="text-sm">{{ employer.salary | money(0) }}</div>
                        </grid-layout-item>

                        <grid-layout-item class="sm:w-1/2 lg:w-1/3 mb-3">
                            <div class="text-label text-xs">Period</div>
                            <div class="text-sm">
                                <base-period
                                    :item="{
                                        starts_at: employer.started_at,
                                        ends_at: employer.finished_at
                                    }"
                                />
                            </div>
                        </grid-layout-item>

                        <grid-layout-item class="sm:w-1/2 lg:w-1/3 mb-3">
                            <div class="text-label text-xs">Contact Name</div>
                            <div class="text-sm">
                                {{ employer.first_name }} {{ employer.last_name }}
                            </div>
                        </grid-layout-item>

                        <grid-layout-item class="sm:w-1/2 lg:w-1/3 mb-3">
                            <div class="text-label text-xs">Contact Email</div>
                            <div class="text-sm">
                                <a-mailto
                                    v-if="employer.email"
                                    :email="employer.email"
                                    class="text-blue"
                                />
                                <base-na v-else />
                            </div>
                        </grid-layout-item>

                        <grid-layout-item class="sm:w-1/2 lg:w-1/3 mb-3">
                            <div class="text-label text-xs">Contact Telephone</div>
                            <div class="text-sm">
                                <a-tel
                                    v-if="employer.telephone"
                                    :telephone="employer.telephone"
                                    class="text-blue"
                                />
                                <base-na v-else />
                            </div>
                        </grid-layout-item>
                    </grid-layout>
                </td>
            </table-ish-row>
        </template>
    </table-ish>
</template>

<script>
    import _ from 'lodash'

    export default {
        props: {
            employers: {
                type: Array,
                required: true
            }
        },
        data () {
            return {
                expanded: []
            }
        },
        methods: {
            toggle (uuid) {
                this.expanded = this.isExpanded(uuid)
                    ? _.without(this.expanded, uuid)
                    : _.union(this.expanded, [uuid])
            },
            isExpanded (uuid) {
                return _.includes(this.expanded, uuid)
            }
        }
    }
</script>
